// Newsletter forms (footer band + popup): remember which form was submitted so that, after Shopify's
// full-page post, only that form shows its result (both customer forms see form.posted_successfully?).
const KEY = 'cl-nl-src';
document.addEventListener('submit', (e) => {
  const f = e.target.closest('[data-nl-form]');
  if (f) try { sessionStorage.setItem(KEY, f.dataset.nlForm); } catch (_) {}
});
let src = null;
try { src = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (_) {}
if (src) {
  document.querySelectorAll('[data-nl-form]').forEach((f) => {
    if (f.dataset.nlForm === src) return;
    f.querySelectorAll('[data-nl-msg]').forEach((m) => m.remove());
    f.querySelector('[aria-invalid]')?.removeAttribute('aria-invalid');
  });
  document.documentElement.dataset.nlPosted = src;
}
